<template>
    <div style="width: 750px;margin: 0 auto;border:1px solid;box-shadow: 5px 5px 5px #888888;">
        <div id="content" style="width: 650px;margin: 0 auto;">

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span>
            </p>

            <p style="margin:0pt; text-align:center">
                <span style="font-family:华文楷体; font-size:16pt; font-weight:bold">购销协议之补充协议</span>
            </p>

            <p style="margin:0pt; text-align:center">
                <span style="font-family:华文楷体; font-size:15pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt">
                <span style="font-family:华文楷体; font-size:10.5pt">本《购销协议之补充协议》（以下简称“<b>本补充协议</b>”） 由以下双方于</span>

                <my-content v-model="contract.year" :val="contract.year"></my-content>
                <span style="font-family:华文楷体; font-size:10.5pt">年</span>

                <my-content v-model="contract.month" :val="contract.month"></my-content>
                <span style="font-family:华文楷体; font-size:10.5pt">月</span>

                <my-content v-model="contract.day" :val="contract.day"></my-content>
                <span style="font-family:华文楷体; font-size:10.5pt">日</span>

                <span style="font-family:华文楷体; font-size:10.5pt">共同签署：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">甲方：</span>
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">天津果敢时代国际贸易有限公司</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">乙方：</span>
                <my-content v-model="contract.Bname" :val="contract.Bname"></my-content>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt">
                <span style="font-family:华文楷体; font-size:10.5pt">甲乙双方于</span>

                <my-content v-model="contract.year1" :val="contract.year1"></my-content>
                <span style="font-family:华文楷体; font-size:10.5pt">年</span>


                <my-content v-model="contract.month1" :val="contract.month1"></my-content>
                <span style="font-family:华文楷体; font-size:10.5pt">月</span>


                <my-content v-model="contract.day1" :val="contract.day1"></my-content>
                <span style="font-family:华文楷体; font-size:10.5pt">日</span>

                <span style="font-family:华文楷体; font-size:10.5pt">签署了的合同号为</span>
                <my-content v-model="contract.code" :val="contract.code"></my-content>

                <span style="font-family:华文楷体; font-size:10.5pt">的《 购销协议 》（以下简称“<b>主协议</b>”），经双方友好协商，就主协议中的若干事项达成以下共识和一致意见：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt 21pt; text-indent:-21pt"><span
                    style="font-family:华文楷体; font-size:10.5pt">1．双方同意合作品牌如下：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">合作品牌：</span>
                <my-content v-model="contract.brand" :val="contract.brand"></my-content>


            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt 21pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">2．双方同意如下结算方式：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">产品按照主协议交付之日起<my-content v-model="contract.days" :val="contract.days"></my-content>天，乙方根据甲方实际完成销售的商品数量向甲方申请结算，双方确认无误后，乙方按主合同发票开具规定向甲方开具发票，甲方收到乙方发票后向乙方支付对应货款。</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
            <span
                    style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt 21pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">3．乙方银行账户信息如下：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">户名：</span>
                <my-content v-model="contract.BaccountName" :val="contract.BaccountName"></my-content>

            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0"><span
                    style="font-family:华文楷体; font-size:10.5pt">开户行：</span>
                <my-content v-model="contract.Bbank" :val="contract.Bbank"></my-content>

            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">账号：</span>
                <my-content v-model="contract.BaccountNum" :val="contract.BaccountNum"></my-content>

            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">乙方的银行账户信息如发生任何变化，应提前30日通知甲方，并提供新的银行账户信息。如因乙方未及时通知甲方而造成任何后果，由乙方承担。</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt 21pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">4．为主协议及本补充协议之目的，双方同意如下保证金事项：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">乙方应当在签订本协议后10日内向甲方支付商品质量和服务保证金，该保证金总金额为人民币<my-content v-model="contract.deposit" :val="contract.deposit"></my-content>元。若乙方未按约定时间支付保证金的，乙方认可甲方有权自应结账款中扣除相应金额作为保证金。</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">甲方保证金银行账户信息如下：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">户名：【天津果敢时代国际贸易有限公司】</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">开户行：【招商银行股份有限公司天津武清支行】</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">账号：【122907366910806】</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt 21pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">5．双方同意就主协议规定退换货补充规定如下：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">在不限制甲方根据主协议享有的任何退货权利和补救办法的条件下，甲方有权要求乙方限期提取退货或更换，相关费用和风险由乙方承担，如乙方逾期不提取退货，甲方有权将退货配送至乙方如下退货地点，退货运费及风险由乙方承担。</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">乙方退货地址：</span>
                <my-content v-model="contract.BreturnAddress" :val="contract.BreturnAddress"></my-content>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">联系人：</span>
                <my-content v-model="contract.BcontactsName" :val="contract.BcontactsName"></my-content>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">联系方式：</span>
                <my-content v-model="contract.BcontactsPhone" :val="contract.BcontactsPhone"></my-content>

            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">乙方的退货地址如发生任何变化，应提前30日通知甲方，并提供新的退货地址。如因乙方未及时通知甲方而造成任何后果，由乙方承担。</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt 21pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">6．为主协议及本补充协议之目的，双方指定如下代理人进行业务沟通：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">甲方指定的代理人：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">姓名：</span>
                <my-content v-model="contract.AagentName" :val="contract.AagentName"></my-content>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">地址：</span>
                <my-content v-model="contract.AagentAddr" :val="contract.AagentAddr"></my-content>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">邮箱：</span>
                <my-content v-model="contract.AagentEmail" :val="contract.AagentEmail"></my-content>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">联系方式：</span>
                <my-content v-model="contract.AagentPhone" :val="contract.AagentPhone"></my-content>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">乙方指定的代理人：</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">姓名：</span>
                <my-content v-model="contract.BagentName" :val="contract.BagentName"></my-content>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">地址：</span>
                <my-content v-model="contract.BagentAddr" :val="contract.BagentAddr"></my-content>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">邮箱：</span>
                <my-content v-model="contract.BagentEmail" :val="contract.BagentEmail"></my-content>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">联系方式：</span>
                <my-content v-model="contract.BagentPhone" :val="contract.BagentPhone"></my-content>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">一方的授权代理人信息如发生任何变化，应提前5个工作日通知另外一方，并提供新的联系人信息。如因乙方未及时通知甲方而造成任何后果，由乙方承担。</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt 21pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">7．甲方在合作期限内累计达成以下采购金额的，乙方应当按照以下标准进行返利：</span>
                <el-button type="text" @click="addDomain">添加</el-button>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0" v-for="item in contract.rebates">
                <span style="font-family:华文楷体; font-size:10.5pt">累计采购金额达到</span>

                <my-content v-model="item.money" :val="item.money"></my-content>

                <span style="font-family:华文楷体; font-size:10.5pt">元人民币，乙方给予甲方累计采购金额</span>
                <my-content v-model="item.ratio" :val="item.ratio"></my-content>

                <span style="font-family:华文楷体; font-size:10.5pt">%的返利；</span>
                <el-button type="text" @click.prevent="removeDelete(item)">删除</el-button>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">甲方有权在应付款项中直接扣除返利金额。</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0"><span
                    style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">8．本补充协议是对主协议的补充，是主协议不可分割的一部分，与主协议拥有同等法律效力，主协议内容与本补充协议的约定不一致时，以本补充协议的内容确定双方的权利义务；本补充协议中未涉及的内容依据主协议履行；</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">9．本补充协议自双方盖章之日起生效，一式贰（2）份，双方各执壹（1）份，具有同等法律效力。</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:center; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt; font-style:italic">[以下无正文]</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&#xa0;</span>
            </p>
            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&#xa0;</span>
            </p>
            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&#xa0;</span>
            </p>

            <table cellspacing="0" cellpadding="0" style="border-collapse:collapse; margin-left:0pt; width:464.3pt">
                <tr style="height:96.8pt">
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:221.35pt">
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">甲方（盖章）：天津果敢时代国际贸易有限公司</span>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>

                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">签约日期：</span>
                            <my-content v-model="contract.AsignYear" :val="contract.AsignYear"></my-content>
                            <span style="font-family:楷体; font-size:10.5pt">年</span>
                            <my-content v-model="contract.AsignMonth" :val="contract.AsignMonth"></my-content>
                            <span style="font-family:楷体; font-size:10.5pt">月</span>
                            <my-content v-model="contract.AsignDay" :val="contract.AsignDay"></my-content>
                            <span style="font-family:楷体; font-size:10.5pt">日</span>
                        </p>
                    </td>
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:221.35pt">
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">乙方（盖章）：</span>
                            <my-content v-model="contract.Bsign" :val="contract.Bsign"></my-content>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>

                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">签约日期：</span>
                            <my-content v-model="contract.BsignYear" :val="contract.BsignYear"></my-content>

                            <span style="font-family:楷体; font-size:10.5pt">年</span>
                            <my-content v-model="contract.BsignMonth" :val="contract.BsignMonth"></my-content>
                            <span style="font-family:楷体; font-size:10.5pt">月</span>
                            <my-content v-model="contract.BsignDay" :val="contract.BsignDay"></my-content>
                            <span style="font-family:楷体; font-size:10.5pt">日</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:29.3pt">
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:221.35pt">
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">授权代表人签字：</span>
                            <my-content v-model="contract.Adeputy" :val="contract.Adeputy"></my-content>
                        </p>
                    </td>
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:221.35pt">
                        <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">授权代表人签字：</span>
                            <my-content v-model="contract.Bdeputy" :val="contract.Bdeputy"></my-content>
                        </p>
                    </td>
                </tr>
            </table>
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>
        </div>
        <div style="padding:20px 0px 15px 0px;text-align: center">
            <el-button type="primary" @click="submitContent()">保 存</el-button>
            <el-button type="primary" @click="findEmpty()">定位未填</el-button>
            <el-button type="primary" @click="returnWindow()">返 回</el-button>
        </div>
    </div>
</template>
<script type="text/javascript">
    export default {
        data () {
            return {
                contract: {

                    year: "",
                    month: "",
                    day: "",

                    Bname: "",

                    year1: "",
                    month1: "",
                    day1: "",

                    code: "",

                    brand: "",

                    days:"",
                    deposit:"",

                    BaccountName: "",
                    Bbank: "",
                    BaccountNum: "",

                    BreturnAddress: "",
                    BcontactsName: "",
                    BcontactsPhone: "",

                    AagentName: "",
                    AagentAddr: "",
                    AagentEmail: "",
                    AagentPhone: "",

                    BagentName: "",
                    BagentAddr: "",
                    BagentEmail: "",
                    BagentPhone: "",

                    rebates: [
                        {
                            money: "",
                            ratio: ""
                        }
                    ],
                    Bsign: "",

                    AsignYear: "",
                    AsignMonth: "",
                    AsignDay: "",

                    BsignYear: "",
                    BsignMonth: "",
                    BsignDay: "",

                    Adeputy: "",
                    Bdeputy: ""
                }
            }
        },
        mounted () {
            var contentId = this.$route.query.contentId;
            var type = this.$route.query.type;
            var templateId = this.$route.query.templateId;

            var isSupplier = this.$route.query.isSupplier;
            this.isSupplier = isSupplier;

            this.type = type;
            this.contentId = contentId;
            this.templateId = templateId;
            this.initContent(contentId, type);
        },
        methods: {
            findEmpty(){
                var el = this.emptyElement(this);
                if(el){
                    el.focus();
                }else{
                    this.$message({
                        message: "已全部填写完毕",
                        type: 'success'
                    });
                }
            },
            emptyElement(object){
                if(object.$children.length > 0 ){
                    for(var key in object.$children){
                        var el = this.emptyElement(object.$children[key]);
                        if(el){
                            return el;
                        }
                    }
                }else{
                    if(object.$options._componentTag === "my-content"
                        && object.$el.innerText == ""){
                        return object.$el;
                    }
                }
                return null;
            },
            isEmpty(value){
                var isEmpty = false;
                if("object" === typeof value){
                    for(var key in value){
                        var empty = this.isEmpty(value[key]);
                        if(empty){
                            return empty;
                        }
                    }
                }else{
                    value = value || "";
                    return value == "" || value == "undefined";
                }
                return isEmpty;
            },
            returnWindow(){
                window.close();
            },
            addDomain() {
                this.contract.rebates.push({
                    money: "",
                    ratio: ""
                });
            },
            removeDelete(item) {
                var index = this.contract.rebates.indexOf(item)
                if (index !== -1) {
                    this.contract.rebates.splice(index, 1)
                }
                console.log(this.contract.rebates)
            },
            submitContent(){
                var that = this;

                //验证信息完整度
                var isEmpty = that.isEmpty(that.contract);

                var data = {
                    templateId: that.templateId,
                    complete:isEmpty ? 0 : 1,
                    content: JSON.stringify(that.contract),
                    type: that.type
                };

                if (that.contentId) {
                    data["contentId"] = that.contentId;
                }

                $.ajax({
                    url: '/suppliers/contract/template/save',
                    data: JSON.stringify(data),
                    dataType: "json",
                    contentType: 'application/json;charset=utf-8',
                    type: 'POST',
                    success: function (result) {
                        if (!result.code) {
                            that.contentId = result.data.templateContentId;
                            var templateData = {templateId:that.templateId,contentId:that.contentId};
                            if(!this.isSupplier ||  this.isSupplier !=1){
                                window.opener.eventHub.$emit('SET_CONTENT_ID', templateData);
                            }
                            window.close();
                        }
                    }
                })
            },
            initContent(contentId, type){
                var that = this;
                if (!contentId) {
                    contentId = 0;
                }
                $.get({
                    url: '/suppliers/contract/template/content',
                    data: {
                        contentId: contentId,
                        type: type
                    },
                    success: function (result) {
                        if (!result.code) {
                            if (($.isEmptyObject(result.data))){
                            } else {
                                that.contract = result.data;
                            }
                        } else {

                        }
                    }
                })
            }
        }
    }
</script>
<style type="text/css" lang="less" scoped>
    .content {
        font-family: 华文楷体;
        font-size: 10.5pt;
        display: -moz-inline-box;
        display: inline-block;
        min-width: 15px;
        border-bottom: 1px solid #ff4a7d;
        min-height: 17px;
    }
    .content:focus {
        outline:none;
    }
</style>



// WEBPACK FOOTER //
// contract_2_1.vue?7e483688